import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "../layout/Sidebar";
import AgentSidebar from "../layout/AgentSidebar";

const AgentAttendanceReportPage = () => {
  const [attendance, setAttendance] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);

  const baseURL = process.env.REACT_APP_BASE_URL;
  const agentId = sessionStorage.getItem("agent_id");
  const role = sessionStorage.getItem("role")
  const SidebarComponent = role === "agent" ? AgentSidebar : Sidebar;

  useEffect(() => {
    if (agentId && startDate && endDate) {
      setLoading(true);
      const accessToken = sessionStorage.getItem("access_token");
      axios
        .get(`${baseURL}/getAgentAttendance`, {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: { agent_id: agentId },
        })
        .then((response) => {
          const data = response.data || [];
          const filtered = data.filter((record) => {
            const date = new Date(record.date1);
            return (
              date >= new Date(startDate) && date <= new Date(endDate)
            );
          });
          setAttendance(filtered);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [agentId, startDate, endDate]);

  const getStatusLabel = (status) => {
    switch (status) {
      case "P":
        return "Present";
      case "A":
        return "Absent";
      case "PER":
        return "Permission";
      case "H":
        return "Half Day";
      default:
        return status;
    }
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";
    const parts = dateString.split("-");
    if (parts.length !== 3) return dateString;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full min-h-screen">
      <SidebarComponent />

      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">
          Agent Attendance Report
        </h2>

        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          {/* Filters */}
          
          <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0 mb-4">
            <div>
              <label className="block text-gray-700">Start Date</label>
              <input
                type="date"
                className="border border-gray-300 rounded p-2 w-full"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-gray-700">End Date</label>
              <input
                type="date"
                className="border border-gray-300 rounded p-2 w-full"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="p-2">S.No</th>
                  <th className="p-2">Date</th>
                  <th className="p-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center p-4">
                      Loading...
                    </td>
                  </tr>
                ) : attendance.length > 0 ? (
                  attendance.map((record, idx) => (
                    <tr
                      key={idx}
                      className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}
                    >
                      <td className="p-2">{idx + 1}</td>
                      <td className="p-2">{formatDisplayDate(record.date1)}</td>
                      <td className="p-2">{getStatusLabel(record.atten_status)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center p-4">
                      No records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AgentAttendanceReportPage;
